import { computed } from 'mobx';

export default class TripModel {
  id;
  store;

  constructor(store, trip) {
    this.store = store;
    this.id = +trip.id;
    this.station_name = trip.station_name
    this.start_date = trip.start_date;
    this.end_date = trip.end_date;
    this.planned_by = trip.planned_by;
    this.commutators = trip.commutators
    this.region = trip.region
  }

  @computed get asJson() {
    return {
      id: +this.id,
      trip_id:+this.trip_id,
      station_name: this.station_name,
      start_date: this.start_date,
      end_date: this.end_date,
      planned_by: this.planned_by,
      commutators: this.commutators,
      region:this.region
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.trip_id = + json.trip_id,
    this.station_name = json.station_name
    this.start_date = json.start_date;
    this.end_date = json.end_date;
    this.planned_by = json.planned_by;
    this.commutators = json.commutators;
    this.region = json.region
  }
}



// WEBPACK FOOTER //
// ./src/models/TripModel.js